import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AgviewsConnectService {

  baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }

  listarAgviewsConnect(params: any): Observable<any> {
    const url = `${this.baseUrl}agviewsConnect`;
    return this.http.get<any>(url, {params});
  }

  buscarId(id: any): Observable<any> {
    const url = `${this.baseUrl}agviewsConnect/buscarIdAgviewConnect/${id}`;
    return this.http.get<any>(url);
  }

  editar(tabletForm: any, tabletId: any): Observable<any> {
    const url = `${this.baseUrl}agviewsConnect/${tabletId}`;
    return this.http.put<any>(url, tabletForm)
  }

  quantidadeAgviewsConnectSemClienteEProduto(): Observable<any> {
    const url = `${this.baseUrl}agviewsConnect/quantidadeAgviewsConnectSemClienteEProduto`;
    return this.http.get<any>(url)
  }
}
